export default (props, vars) =>
  !!vars?.['uselookbook2']?.['lookbook']?.['about'].is_pro_bono;
